import React from 'react';
import '../styles/startGameOverlay.css';
import { useTranslation } from 'react-i18next';

/**
 * Оверлей поверх анимации заставки.
 * Появляется после успешной авторизации.
 *
 * Props:
 *  onStart        — колбэк запуска игры
 *  onEarlyAccess  — колбэк перехода на страницу Early Access (только для вернувшихся пользователей)
 *  user           — объект пользователя из Redux (нужен для проверки onboarding)
 */
const StartGameOverlay = ({ onStart, onEarlyAccess, user }) => {
  const { t } = useTranslation();
  const isReturningUser = user?.onboarding === true;

  return (
    <div className="start-overlay">
      {/* Промо-блок с подсказками */}
      <div className="start-overlay__promo">
        <img src="/gift.png" alt="" className="start-overlay__gift" />
        <div className="start-overlay__promo-text">
          <p>{t('start.promo_win', 'Win GRAM Within 15 Spins')}</p>
          <p>{t('start.promo_pool', '1,000 GRAM Prize Pool for top players')}</p>
          <p>{t('start.promo_share', 'Share Profits With Active Players')}</p>
        </div>
      </div>

      {/* Инфо-карточка NFT */}
      <div className="start-overlay__card">
        <div className="start-overlay__card-icon" />
        <div className="start-overlay__card-text">
          <p className="start-overlay__card-title">{t('start.card_title', 'Get GRAM when your Friend win')}</p>
          <p className="start-overlay__card-subtitle">{t('start.card_subtitle', 'Build a Unique Character & Earn GRAM')}</p>
        </div>
      </div>

      {/* Кнопки */}
      {isReturningUser ? (
        <div className="start-overlay__buttons-row">
          <button className="app-btn app-btn--green start-overlay__button start-overlay__button--start" onClick={onStart}>
            {t('start.start_game', 'Start Game')}
          </button>
          <button className="app-btn app-btn--yellow start-overlay__button start-overlay__button--early" onClick={onEarlyAccess}>
              {t('early.header', 'Empire Packs')}
          </button>
        </div>
      ) : (
          <div className="start-overlay__buttons-row">
            <button className="app-btn app-btn--green start-overlay__button start-overlay__button--full" onClick={onStart}>
              {t('start.start_game', 'Start Game')}
            </button>
          </div>
      )}
    </div>
  );
};

export default StartGameOverlay;
